export default __webpack_public_path__ + "static/media/aliimg.45eb7d83.png";